const colors = {};

/* Primary Colors */
colors.tealish = '#33cccc';
colors.periwinkle = '#9966ff';
colors.white = '#fff';
colors.cloudyBlue = '#cfdae1';
colors.degradeStart = '#ab64f5';
colors.degradeEnd = '#8d85ee';
colors.paleGrey = '#f1f5f7';
colors.bluishGrey = '#859099';
colors.slate = '#4a5365';
colors.blueyGrey = '#acbec7';
colors.cloudyBlue = '#cfdae1';
colors.salmon = '#ff6666';
colors.lightGreyish = '#e0e7ec';
colors.paleOrange = '#ff9966';
colors.greenishTeal = '#33cc99';
colors.lightPeriwinkle = '#ddccff';

export default colors;
